import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';
import { SalaryRange } from '@hh.ru/types-hh-microcore';

import { VacancyCompensation } from 'src/types/compensation';
import MarketRange from 'src/types/marketRange';
import { VacancyAdviceWithStatistics } from 'src/types/vacancyAdvices';

interface Vacancy {
    compensation: VacancyCompensation;
    publicationTime: string;
    vacancyAreaId: number;
    vacancyAreaName: string;
    vacancyId: number;
    vacancyName: string;
}

export enum Rating {
    Sad = '1',
    Halfsad = '2',
    Neutral = '3',
    Halfsmile = '4',
    Smile = '5',
}

export interface VacancyAdvicesModals {
    visible: boolean;
    rating: Rating | null;
    vacancy: Pick<Vacancy, 'vacancyId' | 'vacancyAreaName' | 'vacancyName'>;
    adviceWithStatistics: VacancyAdviceWithStatistics[];
    compensation: VacancyCompensation;
    marketRange: MarketRange;
    salaryRange: SalaryRange;
    numberOfSimilarVacancies: number;
}

const INITIAL_STATE: VacancyAdvicesModals = {
    visible: false,
    rating: null,
    vacancy: {
        vacancyName: '',
        vacancyAreaName: '',
    } as Vacancy,
    adviceWithStatistics: [] as VacancyAdviceWithStatistics[],
    compensation: {} as VacancyCompensation,
    marketRange: {} as MarketRange,
    salaryRange: SalaryRange.NotSpecified,
    numberOfSimilarVacancies: 0,
};

const SET_DATA_VACANCY_ADVICES_MODAL = 'SET_DATA_VACANCY_ADVICES_MODAL';
const SET_VISIBLE_VACANCY_ADVICES_MODAL = 'SET_VISIBLE_VACANCY_ADVICES_MODAL';
const SET_ADVICES_VACANCY_ADVICES_MODAL = 'SET_ADVICES_VACANCY_ADVICES_MODAL';
const SET_RATING_VACANCY_ADVICES_MODAL = 'SET_RATING_VACANCY_ADVICES_MODAL';

interface PayloadTypes {
    [SET_DATA_VACANCY_ADVICES_MODAL]: VacancyAdvicesModals;
    [SET_VISIBLE_VACANCY_ADVICES_MODAL]: boolean;
    [SET_ADVICES_VACANCY_ADVICES_MODAL]: VacancyAdviceWithStatistics[];
    [SET_RATING_VACANCY_ADVICES_MODAL]: Rating | null;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setDataVacancyAdvicesModal = actionCreator(SET_DATA_VACANCY_ADVICES_MODAL);
export const setVisibleVacancyAdvicesModal = actionCreator(SET_VISIBLE_VACANCY_ADVICES_MODAL);
export const setAdvicesVacancyAdvicesModal = actionCreator(SET_ADVICES_VACANCY_ADVICES_MODAL);
export const setRatingVacancyAdvicesModal = actionCreator(SET_RATING_VACANCY_ADVICES_MODAL);

export default createReducer<VacancyAdvicesModals, PayloadTypes>(INITIAL_STATE, {
    [SET_DATA_VACANCY_ADVICES_MODAL]: (state, { payload }) => ({
        ...state,
        ...payload,
    }),
    [SET_VISIBLE_VACANCY_ADVICES_MODAL]: (state, { payload }) => ({
        ...state,
        visible: payload,
    }),
    [SET_ADVICES_VACANCY_ADVICES_MODAL]: (state, { payload }) => ({
        ...state,
        adviceWithStatistics: payload,
    }),
    [SET_RATING_VACANCY_ADVICES_MODAL]: (state, { payload }) => ({
        ...state,
        rating: payload,
    }),
});
